import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/merge.svg'
import { Actor } from './Actor'
import { ActivityEventPosition, ArticleMergedEvent, ActivityEventTrackMode } from './Types'
import { Link } from 'react-router-dom'
import { stopPropagation } from 'utils'

interface Props extends ActivityEventPosition {
  event: ArticleMergedEvent
}

const ArticleMerged = ({ event, ...props }: Props) => {
  const { user, data } = event
  const { branch, general_comment } = data

  return (
    <BaseActivityEvent
      {...props}
      trackMode={ActivityEventTrackMode.Merge}
      icon={<Icon />}
      timestamp={event.timestamp}
      message={general_comment}
      content={
        <>
          <Actor displayName={user.display_name || 'Anonymous user'} userId={user?.id} /> merged a linked copy:{' '}
          <Link to={branch.url} onClick={stopPropagation}>
            {branch.title}
          </Link>
        </>
      }
    />
  )
}

export { ArticleMerged }
